import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  type TerminalPinRegeneratedResult,
  postUsersMeTerminalPinRegenerate,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { terminalPinKeys } from "Api/Queries/UserSettings/useTerminalPinQuery";

type Props = {
  onSuccess?: (pin: string) => void;
  onError?: () => void;
};

export const useRegenerateTerminalPinMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation<TerminalPinRegeneratedResult, Error, void>({
    mutationFn: processResponseWithApiProblemDetails(() =>
      postUsersMeTerminalPinRegenerate(),
    ),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: terminalPinKeys.all });
      onSuccess?.(data.pin);
    },
    onError,
  });
};
